import _styled from "@emotion/styled/base";
import React from 'react';
const LogoContainer = _styled("div", {
  target: "evaok8f0"
})("min-height:", _ref => {
  let {
    placeHolderHeight
  } = _ref;
  return placeHolderHeight ? placeHolderHeight : '80px';
}, ";min-width:", _ref2 => {
  let {
    placeHolderWidth
  } = _ref2;
  return placeHolderWidth ? placeHolderWidth : '57px';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9LYmJMb2dvL0xvZ29JbWFnZVBsYWNlSG9sZGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlnQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvS2JiTG9nby9Mb2dvSW1hZ2VQbGFjZUhvbGRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIEB0eXBlc2NyaXB0LWVzbGludC9leHBsaWNpdC1mdW5jdGlvbi1yZXR1cm4tdHlwZSAqL1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgTG9nb0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gICAgbWluLWhlaWdodDogJHsoeyBwbGFjZUhvbGRlckhlaWdodCB9KSA9PiBwbGFjZUhvbGRlckhlaWdodCA/IHBsYWNlSG9sZGVySGVpZ2h0IDogJzgwcHgnfTtcbiAgICBtaW4td2lkdGg6ICAkeyh7IHBsYWNlSG9sZGVyV2lkdGggfSkgPT4gcGxhY2VIb2xkZXJXaWR0aCA/IHBsYWNlSG9sZGVyV2lkdGggOiAnNTdweCd9O1xuYDtcblxuY29uc3QgTG9nb0ltYWdlUGxhY2VIb2xkZXIgPSAoeyBjaGlsZHJlbiwgcGxhY2VIb2xkZXJXaWR0aCwgcGxhY2VIb2xkZXJIZWlnaHQgfSkgPT4gKFxuICA8TG9nb0NvbnRhaW5lclxuICAgIHBsYWNlSG9sZGVyV2lkdGg9e3BsYWNlSG9sZGVyV2lkdGh9XG4gICAgcGxhY2VIb2xkZXJIZWlnaHQ9e3BsYWNlSG9sZGVySGVpZ2h0fVxuICA+XG4gICAge2NoaWxkcmVufVxuICA8L0xvZ29Db250YWluZXI+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBMb2dvSW1hZ2VQbGFjZUhvbGRlcjtcbiJdfQ== */"));
const LogoImagePlaceHolder = _ref3 => {
  let {
    children,
    placeHolderWidth,
    placeHolderHeight
  } = _ref3;
  return React.createElement(LogoContainer, {
    placeHolderWidth: placeHolderWidth,
    placeHolderHeight: placeHolderHeight
  }, children);
};
export default LogoImagePlaceHolder;
//# sourceMappingURL=LogoImagePlaceHolder.js.map